import React, { useContext } from 'react';
import './projects.css'
import { ProjectContext } from './ProjectContext';
import ProjectCard from '../../components/project-details/ProjectCard';

const ProjectsPage = () => {
  const { projects } = useContext(ProjectContext);

  console.log (<ProjectCard></ProjectCard>);

  return (
    <div className='project-page'>
      <h1>Projects</h1>
      <div className="project-list">
        {projects.map(project => (
          <ProjectCard key={project.id} project={project} />
        ))}
      </div>
    </div>
  );
};

export default ProjectsPage;